import { Phone, MessageCircle } from 'lucide-react';
import { useFadeUp } from '@/hooks/useFadeUp';

export function CTABand() {
  const ref = useFadeUp();

  return (
    <section className="py-12 md:py-16 bg-primary-500">
      <div ref={ref} className="fade-up max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
          Un problème avec votre volet roulant ?
        </h2>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto">
          Contactez-nous dès maintenant pour un diagnostic gratuit et une intervention rapide à Charleroi et dans le Hainaut.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="tel:+3280020410"
            className="btn-primary text-base px-8 py-3.5 inline-flex items-center gap-2 w-full sm:w-auto justify-center"
          >
            <Phone className="w-5 h-5" />
            0800 20 410
          </a>
          <a
            href="https://wa.me/32475585219"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary text-base px-8 py-3.5 inline-flex items-center gap-2 w-full sm:w-auto justify-center border-white/30 hover:bg-white/10"
          >
            <MessageCircle className="w-5 h-5" />
            WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}